module.exports = __webpack_public_path__ + "img/Rectangle.de25cc4d.png";